"use client"

import { PostAJobModal } from "@/components/PostAJobModal"
import type { NovaSession } from "@/types"
import { MyJobPostsSection } from "./components/MyJobPostsSection"
import { useMyJobs } from "./hooks/useMyJobs"
import { useEffect, useMemo } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { SearchParams } from "next/dist/server/request/search-params"

interface Props {
  serverSession: NovaSession
}

export const HirePage: React.FC<Props> = ({ serverSession }) => {
  const { setPostAJobModalOpen, postAJobModalOpen } = useMyJobs()
  const searchParams = useSearchParams()
  const currentParams = useMemo(() => {
    const params: SearchParams = {}
    searchParams?.forEach((value, key) => {
      params[key] = value
    })
    return params
  }, [searchParams])
  const router = useRouter()

  const onClose = () => {
    setPostAJobModalOpen(false)

    router.replace("/hire", undefined)
  }

  useEffect(() => {
    if (currentParams.postAJob === "true") {
      setPostAJobModalOpen(true)
    }
  }, [currentParams, router])

  return (
    <>
      <PostAJobModal open={postAJobModalOpen} onClose={onClose} serverSession={serverSession} entryPoint="hiring" />
      <MyJobPostsSection
        currentUserField={serverSession.account === "client" ? "client" : "creative"}
        serverSession={serverSession}
      />
    </>
  )
}
